import { action } from 'typesafe-actions';
import { CommonTypes } from './types';

export const categoriaRequest = () => action(CommonTypes.CATEGORIA_REQUEST, {});

export const categoriaSuccess = (data: any) =>
  action(CommonTypes.CATEGORIA_SUCCESS, { data });

export const categoriaFailure = () => action(CommonTypes.CATEGORIA_FAILURE, {});

export const companyRequest = (code: any) =>
  action(CommonTypes.COMPANY_REQUEST, { code });

export const companySuccess = (data: any) =>
  action(CommonTypes.COMPANY_SUCCESS, { data });

export const companyFailure = () => action(CommonTypes.COMPANY_FAILURE, {});

export const companyAllRequest = () =>
  action(CommonTypes.COMPANY_ALL_REQUEST, {});

export const companyAllSuccess = (data: any) =>
  action(CommonTypes.COMPANY_ALL_SUCCESS, { data });

export const companyAllFailure = () =>
  action(CommonTypes.COMPANY_ALL_FAILURE, {});
